import styled from "styled-components";
import { Account } from "@dashboard-v3/api";
import Typography from "@material-ui/core/Typography/Typography";
import { grey } from "@material-ui/core/colors";
import AccountTags from "./AccountTags";
import { useTranslation } from "react-i18next";
import StorageProperties from "./StorageProperties";
import { ApprovalGroup } from "../BulkAdd/ImportAccountsModal/types";
import { Skeleton } from "@material-ui/lab";

type Params = {
  account: {
    aliases: string[];
    sourceType: Account["sourceType"];
    groups: string[];
    storage?: Account["storage"];
    tags: string[];
    /** ApprovalGroupId */
    approvalGroup?: string;
    approvalGroups?: string[];
  };
  validateStorage?: boolean;
  approvalGroups?: ApprovalGroup[];
};

export default function ItemContent({
  account,
  validateStorage = false,
  approvalGroups,
}: Params) {
  const { t } = useTranslation("accounts");
  const { aliases, sourceType, groups, storage, tags } = account;

  return (
    <>
      {!isManualSource(sourceType) && (
        <ItemPropertyContainer>
          <PropertyLabel>{t("group")}</PropertyLabel>
          <PropertyValue
            style={{ color: groups.length ? "inherit" : grey[400] }}
          >
            {groups.length ? groups.join(", ") : t("list.noGroups")}
          </PropertyValue>
        </ItemPropertyContainer>
      )}

      <ItemPropertyContainer>
        <PropertyLabel>{t("alias_plural")}</PropertyLabel>
        <PropertyValue>{(aliases || []).join(", ")}</PropertyValue>
      </ItemPropertyContainer>

      <ItemPropertyContainer>
        <PropertyLabel>{t("tag_plural")}</PropertyLabel>
        <AccountTags tags={tags} />
      </ItemPropertyContainer>

      {account.approvalGroups?.length > 0 && (
        <ItemPropertyContainer>
          <PropertyLabel>{t("approvalGroup.label")}</PropertyLabel>
          <ApprovalGroups value={approvalGroups} />
        </ItemPropertyContainer>
      )}

      <ItemPropertyContainer>
        <PropertyLabel>{t("list.storageAccounts")}</PropertyLabel>
        <StorageProperties
          providers={storage}
          validateStorage={validateStorage}
        />
      </ItemPropertyContainer>
    </>
  );
}

function ApprovalGroups({ value }: { value?: ApprovalGroup[] }) {
  if (!value) return <Skeleton width="10rem" height="1.8rem" />;
  const names = value.map(g => g.name || g.email).join(", ");
  return <Typography>{names}</Typography>;
}

const isManualSource = (sourceType: Account["sourceType"]) =>
  sourceType === "MANUAL";

const ItemPropertyContainer = styled.div`
  margin-bottom: 20px;
`;

const PropertyLabel = styled(Typography)`
  color: rgba(0, 0, 0, 0.54);
  font-size: 0.82rem;
  font-weight: 500;
  margin-bottom: 4px;
  text-transform: uppercase;
`;

const PropertyValue = styled(Typography)`
  min-height: 1.5rem;
`;
